import { CATALOG_CATALOG_INDEX_SET_DATA } from 'rebook/apps/catalog/constants';


const initialState = {
  niches: null,
  bestsellersBookset: null,
  lastestBooksets: null,
  audiobooks: null,
};

export default function catalogIndex(state = initialState, action) {
  switch (action.type) {
    case CATALOG_CATALOG_INDEX_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
